export function formatCPF(value: string) {

  const cleaned =
    value.replace(/\D/g, "");

  return cleaned
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2")
    .slice(0, 14);
}

export function formatCEP(value: string) {

  const cleaned =
    value.replace(/\D/g, "");

  return cleaned
    .replace(/^(\d{5})(\d)/, "$1-$2")
    .slice(0, 9);
}

export function formatTitulo(value: string) {

  return value
    .replace(/\D/g, "")
    .slice(0, 12);
}

export function formatSUS(value: string) {

  return value
    .replace(/\D/g, "")
    .slice(0, 15);
}